exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locked{color:#007bff;cursor:pointer}.modal{z-index:30000!important;width:97%;height:90%;margin-top:30px}.modal-title{font-size:26px;font-weight:700;font-family:Open Sans,sans-serif!important;color:#000}.modal-body{font-size:14px;padding:1.7rem}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#0000007d}.btn:active,.btn:focus{outline:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33e31fea","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/mlang/popup-modal/Popup.vue
// module id = uO7v
// module chunks = 0